/** @jsx jsx */
import { Box, Container } from '@bottlebooks/gatsby-theme-base/src';
import EventBannerImage from '@bottlebooks/gatsby-theme-event/src/components/Event/EventBannerImage';
import { jsx } from 'theme-ui';
import ConstrainedImage from '../../../../components/ConstrainedImage';

export * from '@bottlebooks/gatsby-theme-event/src/components/Event/EventBanner';

export default function EventBanner({ event, ...rest }) {
  return (
    <EventBannerImage event={event} {...rest}>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'stretch',
          alignItems: 'stretch',
        }}
      >
        <Container
          // @ts-expect-error sx is missing from type annotation.
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
          }}
        >
          <ConstrainedImage
            publicId="sites/best-of-burgenland-2025/BestOfBurgenland-Overlay.png"
            options={{ crop: 'pad', width: 960, dpr: 3, gravity: 'south_west' }}
            alt={event?.name || ''}
            sx={{
              width: '100%',
              maxWidth: 500,
              display: 'block',
              marginY: 2.5,
              marginX: -4,
            }}
          />
        </Container>
      </Box>
    </EventBannerImage>
  );
}
